module.exports = __webpack_public_path__ + "static/media/motorcycle.80cf8ee6.png";